import * as React from "react";
const SvgLineVertical = (props) => /* @__PURE__ */ React.createElement("svg", { width: 1, height: 32, viewBox: "0 0 1 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("line", { x1: 0.5, y1: 218556e-13, x2: 0.499999, y2: 32, stroke: "#E2E8F0" }));
export default SvgLineVertical;
